import { render } from "./Home.vue?vue&type=template&id=74b1de62&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=74b1de62&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3693190966/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b1de62"],['__file',"src/components/home/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74b1de62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74b1de62', __exports__)) {
    console.log('reload')
    api.reload('74b1de62', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=74b1de62&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('74b1de62', render)
  })

}


export default __exports__